<template>
    <div class="card mb-25 border-0 rounded-0 bg-white add-user-card">
      <div class="card-header">
      <h3 class="text-black fw-semibold">Ajouter un compte client</h3>
    </div>
      <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
          <Form ref="compteForm" @submit="addCompte" :validation-schema="compteSchema">
          <div class="row">
             <div class="col-md-6 mb-3">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black mb-10">
                    Date de création <span class="text-danger">*</span>
                  </label>
                  <Field name="dateCreation" type="date" 
                  class="form-control shadow-none fs-md-15 text-black"/>
                </div>
              <ErrorMessage name="dateCreation" class="text-danger"/>
              </div>
            <div class="col-md-6 mb-3">
              <div class="form-group mb-15 mb-sm-20 mb-md-25">
                <label class="d-block text-black fw-semibold mb-10">
                  Client <span class="text-danger">*</span>
                </label>
                <Field  name="client"  v-slot="{ field }">
                  <Multiselect
                    :options="clientOptions"
                    :searchable="true"
                    track-by="label"
                    label="label"
                    v-model = "field.value"
                    v-bind = "field"
                    placeholder="Sélectionner le client"
                  />
                </Field>  
              </div>
              <ErrorMessage name="client" class="text-danger"/>
            </div>
             <!--<div class="col-md-4 mb-3">
              <div class="form-group mb-15 mb-sm-20 mb-md-25">
                <label class="d-block text-black fw-semibold mb-10">
                  Intitulé compte <span class="text-danger">*</span>
                </label>
                <Field name="intituleCompte" type="text" 
                class="form-control shadow-none fs-md-15 text-black" placeholder="Entrer l' intitule du compte"/>
                <ErrorMessage name="intituleCompte" class="text-danger"/>
              </div>
            </div>-->
           <div class="col-md-6 mb-3">
              <div class="form-group mb-15 mb-sm-20 mb-md-25">
                <label class="d-block text-black fw-semibold mb-10">
                Solde initial <span class="text-danger">*</span>
                </label>
                <Field name="soldeInitial" type="text" 
                class="form-control shadow-none fs-md-15 text-black" placeholder="Entrer le solde initial"/>
                <ErrorMessage name="soldeInitial" class="text-danger"/>
              </div>
            </div>
             <!--<div class="col-md-4 mb-3">
              <div class="form-group mb-15 mb-sm-20 mb-md-25">
                <label class="d-block text-black fw-semibold mb-10">
                Solde Actuel<span class="text-danger">*</span>
                </label>
                <Field name="soldeActuel" type="text" 
                class="form-control shadow-none fs-md-15 text-black" placeholder="Entrer le solde actuel"/>
                <ErrorMessage name="soldeActuel" class="text-danger"/>
              </div>
            </div> -->
           
          
          <div class="col-md-6 mb-3">
          <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Type de compte <span class="text-danger">*</span>
              </label>
              <Field name="typeCompte" type="text" v-slot="{ field }">
                <Multiselect :searchable="true" :options="optionsCompte" v-model="field.value" v-bind="field"
                  placeholder="Sélectionner le type de compte" />
              </Field>
              <ErrorMessage name="typeCompte" class="text-danger" />
            </div>
          </div>
            <div class="col-md-12">
              <div class="d-flex align-items-center ">
                <button
                  class="btn btn-success me-3"
                  type="submit"
                >
                  Créer un compte
                </button>
                <router-link to="/comptes/liste-comptes" 
                    class=" btn btn-danger"><i class="fa fa-trash-o lh-1 me-1 position-relative top-2"></i>
                    <span class="position-relative"></span>Annuler</router-link>
              </div>
            </div>
      </div>
    </Form>
  </div>
</div>
</template>

<script lang="ts">

import { defineComponent, ref, watch, onMounted } from 'vue';
import { Form, Field, ErrorMessage } from 'vee-validate';
import { error, success } from '@/utils/utils';
import { useRouter } from "vue-router";
import ApiService from '@/services/ApiService';
import { Compte } from '@/models/Compte';
import * as Yup from 'yup';
import axios from 'axios';
import Multiselect from '@vueform/multiselect'
import { option } from '@/composables/common/animationView';

export default defineComponent({
    name: "AddCompte",
    components: {
    Form,
    Field,
    ErrorMessage,
    Multiselect
  },
  setup: () => {
    const compteSchema = Yup.object().shape({
      client: Yup.string().required('Le client est obligatoire'),
      dateCreation: Yup.string().required('La date de création est obligatoire'),
      typeCompte: Yup.string().required('Le type de compte est obligatoire'),
      soldeInitial: Yup.number().typeError('Veuillez entrer des chiffres').required('Le solde initial est obligatoire'),
    });

    const compteForm =  ref<Compte | null>(null);
    const router = useRouter();
    const clientOptions = ref([]);
    const typeCompteOptions = ref([]);
    const optionsCompte = ref([
      { value: '1', label: 'Compte Comptant' },
      { value: '2', label: 'Compte Créance' },
      { value: '3', label: 'Compte Dépot-Vente' },
    ]);
    const fetchClient = async () => {
      try {
        const response = await ApiService.get('/all/clients');
        const clientsData = response.data.data;
        clientOptions.value = clientsData.map((client) => ({
          value: client.id,
          label: client.nomClient && client.prenomClient
            ? `${client.nomClient} ${client.prenomClient}`
            : `${client.raisonSociale}`,
        }));
      } catch (error) {
        //
      }
    };

    onMounted(()=> {
      fetchClient();
   
    })

  const addCompte = async (values, { resetForm }) => {
  console.log("Valuerrrrrrrrrs reçus :", values);
  ApiService.post("/comptes", values)
    .then(({ data }) => {
      console.log("Contenu de data :", data); // Ajout de la console pour voir le contenu de data
      if (data.code == 201) { 
        success(data.message);
        resetForm();
        router.push({ name: "ListeCompte" });
      }
    }).catch(({ response }) => {
      error(response.data.message);
    });
};

    return { compteSchema,
       addCompte,
        compteForm,clientOptions,
        typeCompteOptions,
        optionsCompte,
      };
  },
});
</script>